import ListComponent from 'common_components/ui/list/list.component';
import React, { useEffect, useMemo, useRef } from 'react';
import { getDropdownData, useSetState } from 'utils/functions.utils';
import {
  Input,
  PrimaryButton,
  Assets,
  Dropdown,
  Tabs,
  Navbutton,
  Searchbar,
  Sidebar,
  Navbar,
  Colors,
  MultiSelectDropdown,
  Slider,
  TextEditor,
  CheckBox,
  Share,
  Models,
  Prompt,
} from 'utils/imports.utils';
import './test.scss';
import Creatable, { useCreatable } from 'react-select/creatable';
import CreatableSelect from 'react-select/creatable';
import FileUpload from 'common_components/ui/file_upload/file_upload.ui';
const csvtojson = require('csvtojson');
import ApiCalendar from 'react-google-calendar-api';
import moment from 'moment';
import { nanoid } from 'nanoid';
import Async, { useAsync } from 'react-select/async';
import AsyncSelect from 'react-select/async';
import { REQUISITION_STATUS } from 'utils/constant.utils';
// import csvFilePath from '../../assets/docs/addresses.csv';
import csvDownload from 'json-to-csv-export';
// import {
//   CardNumberElement,
//   CardExpiryElement,
//   CardCVCElement,
//   injectStripe
// } from 'react-stripe-elements'
export const Test = (props) => {
  //  const stripe: any = useStripe();
  // const elements:any = useElements();
  const inputFileRef: any = useRef();
  const quillRef: any = React.useRef(null);
  const quill: any = quillRef.current;

  const [state, setState] = useSetState({
    value: '',
    options: [
      { value: 'Recruiter', label: 'Recruiter' },
      { value: 'Hiring manager', label: 'Hiring manager' },
      { value: 'Interviewer', label: 'Interviewer' },
    ],
    files: [],
  });
  const arrayvalues = [
    'Small',
    'Medium',
    'EnterPrise',
    'Small',
    'Medium',
    'EnterPrise',
  ];
  let options = [
    { value: 'Recruiter', label: 'Recruiter' },
    { value: 'Hiring manager', label: 'Hiring manager' },
    { value: 'Interviewer', label: 'Interviewer' },
  ];

  const titleData = [
    { label: 'Name', value: 'name', width: '25%' },
    { label: 'Job Requisition', value: 'requisition', width: '25%' },
    { label: 'Interview date', value: 'interview_date', width: '15%' },
    // { label: '', style: { width: '20%' } },
  ];

  const data = [
    {
      name: 'Sairamm',
      requisition: 'Developer',
      interview_date: 'Thursday, 23 May',
    },
  ];

  const deleteUser = () => {
    console.log('delete user');
  };

  const resendInvite = () => {
    console.log('resend invite');
  };

  let actionArray = {
    style: { width: '30%' },
    actions: [
      {
        component: (item: any) => {
          return (
            <div style={{}}>
              <PrimaryButton
                text={'View offer letter'}
                className={'list_component_action_btn'}
                icon={props.action_btn_icon}
                onClick={() => props.onPress()}
              />
            </div>
          );
        },
      },
      {
        component: (item: any) => {
          return (
            <div style={{}}>
              <PrimaryButton
                text={'Approve'}
                className={'list_component_action_btn'}
                icon={props.action_btn_icon}
                onClick={() => props.onPress()}
              />
            </div>
          );
        },
      },
      {
        component: (item: any) => {
          return (
            <div style={{}}>
              <PrimaryButton
                text={'Reject'}
                className={'list_component_action_btn'}
                icon={props.action_btn_icon}
                onClick={() => props.onPress()}
              />
            </div>
          );
        },
      },
    ],
  };

  const createOption = (label: string) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ''),
  });

  const handleChange = (newValue: any, actionMeta: any) => {
    setState({ value: newValue });
  };

  const handleCreate = (inputValue: string) => {
    setState({ isLoading: true });
    // setTimeout(() => {
    const newOption = createOption(inputValue);
    setState({
      isLoading: false,
      options: [...options, newOption],
      value: newOption,
    });
    console.log([...options, newOption]);
    // }, 1000);
    setState({ isLoading: false });
  };

  useEffect(() => {}, []);
  const config = {
    clientId:
      '1083401390587-so8070shu7skq3gg33vdj9nmuh1o0ra4.apps.googleusercontent.com',
    apiKey: 'AIzaSyDNsl9bRxyY2bfNG26jrbh79b1TyDuBCgQ',
    scope: 'https://www.googleapis.com/auth/calendar',
    discoveryDocs: [
      'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
    ],
  };
  // let end_time = moment(new Date(moment(`${date} ${interview.to}`).format())).format()
  // let end_time = moment(new Date(moment(`${date} ${interview.to}`).format())).format()

  const apiCalendar = new ApiCalendar(config);

  var urlRegex = /(https?:\/\/[^ ]*)/;

  var input: any =
    'hei dude, check this link www.askhugo.augmo.io and www.api.affinda.com/docs#post-/invoices asjfb sadf n adshjf hjsdf hjasd https://www.notion.so/a0cab4ec605940a1b5d509fd2506cff8?v=5a7031bdd392444a86f3f7824366bd91&p=ab3efd724ae74ecc81c1f719e60b43bd';
  var url = input.match(urlRegex);

  // var matches = input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  console.log(input.split(' '));
  console.log(
    input
      .split(' ')
      .map((item) =>
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(
          item,
        ),
      ),
  );
  // return matches

  console.log(url);
  const calendarApi = async () => {
    try {
      let stDate = new Date('2021-07-01T12:00:00+05:30');
      let endDate = new Date('2021-07-01T15:00:00+05:30');
      const event: any = {
        summary: 'Interview for Javascript developer',
        location: 'Brown button kilpauk',
        description: "A chance to hear more about Google's developer products.",
        start: {
          dateTime: moment().add(1, 'hour'),
          timeZone: 'Asia/Kolkata',
        },
        end: {
          dateTime: moment().add(2, 'hours'),
          timeZone: 'Asia/Kolkata',
        },
        // recurrence: ['RRULE:FREQ=DAILY;COUNT=1'],
        attendees: [{ email: 'kishore@brownbutton.io' }],
        reminders: {
          useDefault: false,
          overrides: [
            { method: 'email', minutes: 24 * 60 },
            { method: 'popup', minutes: 10 },
          ],
        },
        // conferenceData: {
        //   createRequest: {
        //     requestId: nanoid(10),
        //     conferenceSolutionKey: { type: 'hangoutsMeet' },
        //   },
        // },
        conferenceData: {
          createRequest: {
            conferenceSolutionKey: {
              type: 'hangoutsMeet',
            },
            requestId: nanoid(10),
          },
        },
        // conferenceDataVersion: 1,
      };
      // const res: any = await apiCalendar.createEventFromNow({
      //   time: 120,
      //   summary: 'Interview for Javascript developer',
      // });
      // apiCalendar.
      const res: any = await apiCalendar.createEvent(
        event,
        'sairam@brownbutton.io',
        'all',
      );
      console.log('res', res);
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleAuth = async (name?: string) => {
    try {
      if (name == 'logout') {
        const res: any = await apiCalendar.handleSignoutClick();
        console.log('res', res);
      } else {
        const res: any = await apiCalendar.handleAuthClick();
        console.log('res', res);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const deleteEvent = async () => {
    try {
      const res: any = await apiCalendar.deleteEvent(
        '1mi70gefqjrjnhc7vkcjf5b8m0',
        undefined,
      );
      console.log('res-delete', res);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getRecquisitionLists = async () => {
    try {
      const res: any = await Models.jobRecquisition.getNewRecquisition({
        limit: 1,
        skip: 0,
        status: REQUISITION_STATUS.OPEN,
      });
      // dispatch
      let req_list: any = [];
      res.data.docs.map((item: any) =>
        req_list.push({ label: item?.job_title, value: item._id }),
      );
      setState({ req_list });
    } catch (error: any) {}
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void,
  ) => {
    console.log('callback', callback);
    console.log('inputValue', inputValue);
    // setTimeout(() => {
    callback(promiseOptions());
    // }, 1000);
  };
  // const createEvent = async (interview_id: string) => {
  //   try {
  //     let body = {
  //       start_time: state.start_time,
  //       end_time: state.end_time,
  //       interview_id,
  //     };
  //     const res: any = await Models.auth.createEvent(body);
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // };

  // const updateEvent = async (interview_id: string) => {
  //   try {
  //     let body = {
  //       interview_id,
  //       start_time: state.start_time,
  //       end_time: state.end_time,
  //     };
  //     const res: any = await Models.auth.updateEvent(body);
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // };

  const promiseOptions = async () => {
    return [
      { value: 'Recruiter', label: 'Recruiter' },
      { value: 'Hiring manager', label: 'Hiring manager' },
      { value: 'Interviewer', label: 'Interviewer' },
    ];
    // try {
    //   const res: any = await Models.jobRecquisition.getNewRecquisition({
    //     limit: state.limit,
    //     skip: 1,
    //     status: REQUISITION_STATUS.OPEN,
    //   });
    //   // dispatch
    //   let req_list: any = [];
    //   res.data.docs.map((item: any) =>
    //     req_list.push({ label: item?.job_title, value: item._id }),
    //   );
    //   setState({ req_list });
    //   return req_list
    // } catch (error: any) {}
  };
  // createEvent: async (req: IRequest, res: IResponse, next: INextFunction) => {
  //   try {
  //     await createEvent(req.body);
  //     res.send({ status: USER_RESPONSE.SUCCESS, message: USER_RESPONSE.GOOGLE_EVENTS_FETCHED, data: [] });
  //   } catch (err) {
  //     err.description = USER_RESPONSE.GOOGLE_FAILED_TO_CREATE_EVENT;
  //     next(err);
  //   }
  // },
  // updateEvent: async (req: IRequest, res: IResponse, next: INextFunction) => {
  //   try {
  //     await updateEvent(req.body);
  //     res.send({ status: USER_RESPONSE.SUCCESS, message: USER_RESPONSE.GOOGLE_EVENTS_FETCHED, data: [] });
  //   } catch (err) {
  //     err.description = USER_RESPONSE.GOOGLE_FAILED_TO_CREATE_EVENT;
  //     next(err);
  //   }
  // },

 
  const payment = async () => {
    //stripe
    // const { error, paymentMethod } = await stripe.createPaymentMethod({
    //   type: "card",
    //   card: elements.getElement(CardElement),
    // });
    // console.log('error', error);
    // console.log('paymentMethod', paymentMethod);
    // const handleRazorPayCallback = async (response) => {
    //   console.log('response', response);
    //   let paymentResponse = response;
    // };
    // const paymentOptions = {
    //   key: 'rzp_test_771iEtUnnCuP73', // Enter the Key ID generated from the Dashboard
    //   amount: 100,
    //   currency: 'INR',
    //   name: 'AskHugo',
    //   description: 'AskHugo',
    //   handler: handleRazorPayCallback,
    //   theme: {
    //     color: '#9C312B',
    //   },
    // };
    // const windows: any = window;
    // const paymentObject = new windows.Razorpay(paymentOptions);
    // paymentObject.open();
  };

  // useEffect(() => {
  //   const script = document.createElement('script');
  //     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  //     script.onerror = () => {
  //       console.log('Razorpay SDK failed to load. Are you online?');
  //     };
  //     document.body.appendChild(script);
  // },[])


  let syncData = {
    id: 922921026,
    firstName: 'Dan',
    lastName: 'Wright',
    phone: '5635055595',
    email: 'rite1978@yahoo.com',
    date: 'November 1, 2022',
    time: '9:00am',
    endTime: '10:00am',
    dateCreated: 'October 27, 2022',
    datetimeCreated: '2022-10-27T16:45:44-0500',
    datetime: '2022-11-01T09:00:00-0500',
    price: '2565.00',
    priceSold: '2565.00',
    paid: 'yes',
    amountPaid: '2565.00',
    type: '2 Week Board and Train',
    appointmentTypeID: 33620475,
    classID: null,
    addonIDs: [],
    category: '',
    duration: '60',
    calendar: '2 Week Board and Train',
    calendarID: 6870701,
    certificate: null,
    confirmationPage:
      'https://app.squarespacescheduling.com/schedule.php?owner=26312736&action=appt&id%5B%5D=24b13e4ce32b9a09c1d50d848ce9d9cc',
    location: 'Hauberg Estate Park, Rock Island, IL',
    notes: 'PIF 27Oct22 via NMIACH 10% rescue discount\r\nTSA signed 27Oct22',
    timezone: 'America/Chicago',
    calendarTimezone: 'America/Chicago',
    canceled: false,
    canClientCancel: false,
    canClientReschedule: false,
    labels: null,
    forms: [
      {
        id: 2092782,
        name: 'Board and Train',
        values: [
          {
            id: 3800108783,
            fieldID: 11670889,
            value: '',
            name: 'Your turnover date is (for OLK9 use only)',
          },
          {
            id: 3800108786,
            fieldID: 11670893,
            value: 'Sara',
            name: 'Assigned Trainer (OLK9 Use Only)',
          },
          {
            id: 3800108788,
            fieldID: 11670894,
            value: 'olk9sara@gmail.com',
            name: 'Trainers Email Address (OLK9 Use Only)',
          },
          {
            id: 3800108790,
            fieldID: 11670895,
            value: '',
            name: 'What is your address?',
          },
          {
            id: 3800108792,
            fieldID: 11670897,
            value: 'Beau',
            name: "What is your dog's name?",
          },
          {
            id: 3800108794,
            fieldID: 11670904,
            value: '',
            name: 'What breed is your dog?',
          },
          {
            id: 3800108796,
            fieldID: 11670906,
            value: '',
            name: 'How old is your dog?',
          },
          {
            id: 3800108798,
            fieldID: 11670907,
            value: 'Female',
            name: "What is your dog's gender?",
          },
          {
            id: 3800108800,
            fieldID: 11670908,
            value: '',
            name: 'Is your dog microchipped?',
          },
          {
            id: 3800108802,
            fieldID: 11670909,
            value: '',
            name: 'If yes, please provide microchipped number.',
          },
          {
            id: 3800108805,
            fieldID: 11670910,
            value: '',
            name: 'Is your dog spayed/neutered?',
          },
          {
            id: 3800108807,
            fieldID: 11670911,
            value: '',
            name: 'If yes, please provide the age he/she was fixed?',
          },
          {
            id: 3800108809,
            fieldID: 11670912,
            value: '',
            name: 'Does your dog have any pre-existing conditions (heart, physical, breathing, neurological, etc)? If Yes, do they take any medications? If No, do they take any other medications and why? Write "N/A" if applicable.',
          },
          {
            id: 3800108810,
            fieldID: 11670913,
            value: '',
            name: 'Has your dog ever had surgery? If Yes, when and what type? Does it impact their mobility or ability to participate in training activities? Write "N/A" if applicable',
          },
          {
            id: 3800108811,
            fieldID: 11670915,
            value: '',
            name: 'Does your dog have separation anxiety? If Yes, how does it manifest for the dog (barking, whining, shaking)? If Yes, do they take medications or other supplements to treat?',
          },
          {
            id: 3800108812,
            fieldID: 11670927,
            value: '',
            name: 'Is your dog friendly with other dogs?',
          },
          {
            id: 3800108813,
            fieldID: 11670930,
            value: '',
            name: 'If not, we can assist. Please describe behavior.',
          },
          {
            id: 3800108814,
            fieldID: 11670933,
            value: '',
            name: 'Has your dog ever bitten another dog or human? Dogs with a bite history are not suitable for the Board and Train.  If so, what was the extent? Did it require a hospital/vet visit? Write "N/A" if applicable',
          },
          {
            id: 3800108815,
            fieldID: 11670936,
            value: '',
            name: 'Has your dog displayed any reactivity/aggression towards other dogs or humans? If so, describe in detail below. Otherwise mark as N/A',
          },
          {
            id: 3800108816,
            fieldID: 11670937,
            value: '',
            name: 'Briefly describe any other issues you are having with your dog. For ex: Leash pulling, jumping on people, and bolting out the door. It is imperative that you report any reactiveness to people or dogs for the safety of our Trainers and other clients. *',
          },
          {
            id: 3800108817,
            fieldID: 11670938,
            value: '',
            name: 'Please provide the contact information for your vet.',
          },
          {
            id: 3800108818,
            fieldID: 11670939,
            value: '',
            name: 'In case of emergency, does the trainer have your permission to use the closest vet?',
          },
          {
            id: 3800108819,
            fieldID: 11670940,
            value: '',
            name: 'Is your dog on medication or have any known allergies/sensitivities? If yes, please provide the details, including dosage and care instructions.',
          },
          {
            id: 3800108820,
            fieldID: 11670941,
            value: '',
            name: "Please outline your dog's eating schedule: type of food, amount and frequency. Please remember to provide ample food (and treats if applicable) for your dog's stay.",
          },
          {
            id: 3800108821,
            fieldID: 11670943,
            value: '',
            name: 'Where does your dog sleep at night?',
          },
          {
            id: 3800108822,
            fieldID: 11670944,
            value: '',
            name: 'Is your dog crate or kennel trained?',
          },
          {
            id: 3800108823,
            fieldID: 11670945,
            value: '',
            name: 'Has your dog ever slept away from home before or away from owners?',
          },
          {
            id: 3800108824,
            fieldID: 11670951,
            value: '',
            name: "Please upload your dog's vaccination form. *If form is not available at time of reservation, please email it to customerservice@olk9ca.com prior to training.*Please continue with reservation.",
          },
          {
            id: 3800108825,
            fieldID: 11670953,
            value: '',
            name: 'Alternate POC for emergencies (Name, Number, Email, Address)',
          },
          {
            id: 3800108826,
            fieldID: 11670970,
            value: '',
            name: 'Please check to acknowledge that you have read, consent to, and understand our Training Services Agreement, which covers our policies. You will also be sent a copy for your signature. https://centralcoastdogtrainers.com/our-policies/',
          },
          {
            id: 3800108827,
            fieldID: 11670972,
            value: '',
            name: 'You will receive an email with the TSA document for digital signature shortly after booking. Prior to training starting, this form must be signed and returned.',
          },
          {
            id: 3800108828,
            fieldID: 11670973,
            value: '',
            name: 'Please initial below to indicate all questions were accurately and truthfully answered. Intentional failure to disclose or deliberate omissions of a dogs medical, bite, aggression or reactivity history invalidates training warranty.',
          },
        ],
      },
    ],
    formsText:
      'Name: Dan Wright\nPhone: (563) 505-5595\nEmail: rite1978@yahoo.com\nPrice: $2,565.00\nPaid Online: $2,565.00\n\nLocation\n============\nHauberg Estate Park, Rock Island, IL\n\n\nBoard and Train\n============\nYour turnover date is (for OLK9 use only): \n\nAssigned Trainer (OLK9 Use Only): Sara\n\nTrainers Email Address (OLK9 Use Only): olk9sara@gmail.com\n\nWhat is your address?: \n\nWhat is your dog\'s name?: Beau\n\nWhat breed is your dog?: \n\nHow old is your dog?: \n\nWhat is your dog\'s gender?: Female\n\nIs your dog microchipped?: \n\nIf yes, please provide microchipped number.: \n\nIs your dog spayed/neutered?: \n\nIf yes, please provide the age he/she was fixed?: \n\nDoes your dog have any pre-existing conditions (heart, physical, breathing, neurological, etc)? If Yes, do they take any medications? If No, do they take any other medications and why? Write "N/A" if applicable.: \n\nHas your dog ever had surgery? If Yes, when and what type? Does it impact their mobility or ability to participate in training activities? Write "N/A" if applicable: \n\nDoes your dog have separation anxiety? If Yes, how does it manifest for the dog (barking, whining, shaking)? If Yes, do they take medications or other supplements to treat?: \n\nIs your dog friendly with other dogs?: \n\nIf not, we can assist. Please describe behavior.: \n\nHas your dog ever bitten another dog or human? Dogs with a bite history are not suitable for the Board and Train.  If so, what was the extent? Did it require a hospital/vet visit? Write "N/A" if applicable: \n\nHas your dog displayed any reactivity/aggression towards other dogs or humans? If so, describe in detail below. Otherwise mark as N/A: \n\nBriefly describe any other issues you are having with your dog. For ex: Leash pulling, jumping on people, and bolting out the door. It is imperative that you report any reactiveness to people or dogs for the safety of our Trainers and other clients. : \n\nPlease provide the contact information for your vet.: \n\nIn case of emergency, does the trainer have your permission to use the closest vet?: \n\nIs your dog on medication or have any known allergies/sensitivities? If yes, please provide the details, including dosage and care instructions.: \n\nPlease outline your dog\'s eating schedule: type of food, amount and frequency. Please remember to provide ample food (and treats if applicable) for your dog\'s stay.: \n\nWhere does your dog sleep at night?: \n\nIs your dog crate or kennel trained?: \n\nHas your dog ever slept away from home before or away from owners?: \n\nPlease upload your dog\'s vaccination form. **If form is not available at time of reservation, please email it to customerservice@olk9ca.com prior to training.*Please continue with reservation.: \n\nAlternate POC for emergencies (Name, Number, Email, Address): \n\nPlease check to acknowledge that you have read, consent to, and understand our Training Services Agreement, which covers our policies. You will also be sent a copy for your signature. https://centralcoastdogtrainers.com/our-policies/: \n\nYou will receive an email with the TSA document for digital signature shortly after booking. Prior to training starting, this form must be signed and returned.: \n\nPlease initial below to indicate all questions were accurately and truthfully answered. Intentional failure to disclose or deliberate omissions of a dogs medical, bite, aggression or reactivity history invalidates training warranty.: \n\n',
  };


  return (
    <div style={{ width: '100%' }}>
      {/* <Prompt open={state.open} /> */}
      {/* <PrimaryButton
        text={'pay'}
        className={'login_btn'}
        onClick={() =>
          payment()
        }
         onClick={() => handleAuth('logout')}
         onClick={() => calendarApi()}
         onClick={() => deleteEvent()}
      /> */}
      {/* <Share
        facebook={{
          quote: 'javascript developer',
          url: `https://askhugo-client.augmo.io/apply_job?req_id=213`,
        }}
        email={{
          body: '',
          subject: `Application for ${'javascript developer'}`,
          url: `https://askhugo-client.augmo.io/apply_job?req_id=213`,
        }}
        linkedIn={{
          title: 'javascript developer',
          summary: '',
          url: `https://askhugo-client.augmo.io/apply_job?req_id=213`,
        }}
        {...props}
      /> */}
      {/* <Share
        facebook={{
          quote: 'new post',
          url: 'www.google.com',
        }}
        email={{
          body: '',
          subject: '',
        }}
        linked={{ title: '', summary: '', source: '' }}
        {...props}
      /> */}
      {/* <ListComponent
        titleArray={titleData}
        data={data}
        type="requisition_table"
        actionArray={actionArray}
        // onPress={() => navigate('/login')}
      /> */}
      {/* <TextEditor onChange={(content: string) => console.log(content)} /> */}
      {/* <CheckBox onChange={(value: any) => console.log(value)} /> */}
      {/* <Slider /> */}
      {/* <PrimaryButton
        text={'Login'}
        className={'login_btn'}
        onClick={() => inputFileRef?.current?.openUpload()}
      /> */}
      {/* <FileUpload
        ref={inputFileRef}
        multiple
        onChange={(file: any) => {
          let fileArray: any[] = state.files;
          fileArray.push(file);
          setState({ files: fileArray });
          console.log('fileArray', fileArray);
          // PromisifiedCsvToJson(file);
        }}> */}
      {/* </FileUpload> */}
      {/* <img src={state.profile} /> */}
      {/* <MultiSelectDropdown
        data={options}
        onChange={(data: any) => console.log(data)}
      /> */}
      {/* <CreatableSelect
        isClearable
        isMulti
        styles={customStyles}
        isDisabled={state.isLoading}
        isLoading={state.isLoading}
        onChange={handleChange}
        onCreateOption={handleCreate}
        options={state.options}
        // value={state.value}
      /> */}
      {/* <ListComponent
        titleArray={titleData}
        data={data}
        type="user_table"
        action_btn="Delete location"
        action_btn_icon={Assets.trash}
        actionArray={actionArray}
        // onPress={() => navigate('/login')}
      /> */}
      {/* <Sidebar /> */}
      {/* <Searchbar
        onChange={(value) => {
          setState({ password: value });
        }}
        value={state.password}
        name={'password'}
        iconOnPress={() => setState({ visible: !state.visible })}
      /> */}
      {/* <Navbar/> */}
      {/* <TableListComponent
        action_btn="Resend Invite"
        action_btn_icon={Assets.plus_with_box}
        titleArray={titleData}
        data={data}
      /> */}
      {/* <Dropdown
        data={role_data}
        isMulti
        setActive={(value: any) => {
          setState({ role: value.value });
        }}
        {...props}
      /> */}
    </div>
    // <div style={{ width: '300px' }}>
    //   <Navbutton  className="classname1" icon={Assets.bell} badge={2}/>
    //   {/* <Tabs
    //     data={['Hiring for myself', 'Hiring for clients']}
    //     selected={(value: string) => console.log(value)}
    //   /> */}
    // </div>
    // {/* <Dropdown
    //   data={arrayvalues}
    //   setActive={(value: string) => console.log(value)}
    // /> */}
    // <div
    //   style={{
    //     width: '100%',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //   }}>
    //   <div style={{ width: '400px' }}>
    //     <Input
    //       type="text"
    //       onChange={(e: any) => {
    //         setState({ value: e.target.value });
    //       }}
    //       value={state.value}
    //       name="password"
    //     />
    //   </div>
    // </div>
  );
};

// export sample {
//     "data": {
//         "certifications": [
//             "Staff and User Training"
//         ],
//         "dateOfBirth": null,
//         "education": [
//             {
//                 "organization": "HGFZ Graduate Center",
//                 "accreditation": {
//                     "education": "Master of Project Management",
//                     "educationLevel": "masters",
//                     "inputStr": "Masters in Project Management",
//                     "matchStr": ""
//                 },
//                 "grade": null,
//                 "location": null,
//                 "dates": {
//                     "startDate": "2013-01-01",
//                     "completionDate": "2014-12-01",
//                     "isCurrent": false
//                 }
//             },
//             {
//                 "organization": "CLIFFMOOR COLLEGE",
//                 "accreditation": {
//                     "education": "BA Product Design",
//                     "educationLevel": null,
//                     "inputStr": "BA Product Design",
//                     "matchStr": ""
//                 },
//                 "grade": {
//                     "raw": "GPA: 3.26",
//                     "value": "3.26",
//                     "metric": "GPA"
//                 },
//                 "location": null,
//                 "dates": {
//                     "startDate": "2008-12-01",
//                     "completionDate": "2012-12-01",
//                     "isCurrent": false
//                 }
//             }
//         ],
//         "emails": [
//             "hello@reallygreatsite.com"
//         ],
//         "location": {
//             "formatted": "Independence, KS 67301, USA",
//             "streetNumber": null,
//             "street": null,
//             "apartmentNumber": null,
//             "city": "Independence",
//             "postalCode": "67301",
//             "state": "Kansas",
//             "country": "United States",
//             "rawInput": "St.,",
//             "countryCode": "US"
//         },
//         "name": {
//             "raw": "OLIVIAWILSON",
//             "last": "",
//             "first": "Oliviawilson",
//             "title": "",
//             "middle": ""
//         },
//         "objective": "",
//         "phoneNumbers": [],
//         "publications": [],
//         "referees": [],
//         "sections": [
//             {
//                 "sectionType": "PersonalDetails",
//                 "bbox": [
//                     249.53685,
//                     87.11733515518189,
//                     481.2069,
//                     162.58175015518188
//                 ],
//                 "pageIndex": 0,
//                 "text": "OLIVIAWILSON IT PROJECT MANAGER"
//             },
//             {
//                 "sectionType": "PersonalDetails",
//                 "bbox": [
//                     40.03412,
//                     233.79788015518187,
//                     172.38838,
//                     373.60043015518187
//                 ],
//                 "pageIndex": 0,
//                 "text": "CONTACT ME AT Office Address: 123 Anywhere St., Any City, State, Country 12345 hello@reallygreatsite.com www.reallygreatsite.com @reallygreatsite"
//             },
//             {
//                 "sectionType": "Summary",
//                 "bbox": [
//                     248.77455,
//                     233.79788015518187,
//                     547.21875,
//                     296.2973301551819
//                 ],
//                 "pageIndex": 0,
//                 "text": "PERSONAL PROFILE I am an IT project manager with holistic knowledge of software development and design. I am also experienced in coordinating with stakeholders."
//             },
//             {
//                 "sectionType": "WorkExperience",
//                 "bbox": [
//                     248.59204,
//                     331.39688015518186,
//                     554.23193,
//                     525.8530301551818
//                 ],
//                 "pageIndex": 0,
//                 "text": "WORK EXPERIENCE Project Manager Westheon FGW | Oct 2017 - present Conduct day-to-day project coordination, planning, and implementation across multiple teams Create functional and technical application documents Senior UX Designer Pixelpoint Hive | Jan 2014 - Sept 2017 Managed complex projects from start to finish Collaborated with other designers Translated requirements into polished, high-level designs"
//             },
//             {
//                 "sectionType": "Skills/Interests/Languages",
//                 "bbox": [
//                     39.927242,
//                     420.2973301551819,
//                     173.24226,
//                     603.9448301551819
//                 ],
//                 "pageIndex": 0,
//                 "text": "SKILLS SUMMARY Project Management Software Development Budgeting and Cost Analysis Enterprise Resource Planning Staff and User Training Process Improvement"
//             },
//             {
//                 "sectionType": "Education",
//                 "bbox": [
//                     249.05516,
//                     564.6993701551819,
//                     550.4647,
//                     779.5668001551819
//                 ],
//                 "pageIndex": 0,
//                 "text": "EDUCATIONAL HISTORY HGFZ Graduate Center Masters in Project Management | Jan 2013 - Dec 2014 Studied project planning, coordination, and ethics Worked with various startups on launching new apps and services Cliffmoor College BA Product Design | Dec 2008 - Dec 2012 GPA: 3.26 Minor in Management Thesis involved studying several technology companies and optimizing their product design process"
//             },
//             {
//                 "sectionType": "Achievements",
//                 "bbox": [
//                     39.830154,
//                     648.7983601551819,
//                     178.59694,
//                     777.0308301551819
//                 ],
//                 "pageIndex": 0,
//                 "text": "AWARDS RECEIVED Most Outstanding Employee of the Year, Pixelpoint Hive (2015) Best Mobile App Design, HGFZ Graduate Center (2014) Design Awards, Cliffmoor College (2012)"
//             }
//         ],
//         "skills": [
//             {
//                 "name": "Budgeting",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Personal Profile",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Summary",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Planning",
//                 "lastUsed": "2022-05-27",
//                 "numberOfMonths": 56,
//                 "type": "soft_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     },
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     },
//                     {
//                         "section": "WorkExperience",
//                         "position": 0
//                     },
//                     {
//                         "section": "WorkExperience",
//                         "position": 0
//                     }
//                 ]
//             },
//             {
//                 "name": "Resource Planning",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Project Coordination",
//                 "lastUsed": "2022-05-27",
//                 "numberOfMonths": 56,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "WorkExperience",
//                         "position": 0
//                     }
//                 ]
//             },
//             {
//                 "name": "Enterprise Resource Planning",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Oct",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "soft_skill",
//                 "sources": [
//                     {
//                         "section": "WorkExperience",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Project Management Software",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Personal Profiles",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Summary",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Software Development",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     },
//                     {
//                         "section": "Summary",
//                         "position": null
//                     },
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     },
//                     {
//                         "section": "Summary",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Coordinating",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "soft_skill",
//                 "sources": [
//                     {
//                         "section": "Summary",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Contact",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "PersonalDetails",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Management",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "soft_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "User Experience Design (UX)",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "WorkExperience",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Mobile App",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Achievements",
//                         "position": null
//                     }
//                 ]
//             },
//             {
//                 "name": "Project Management",
//                 "lastUsed": null,
//                 "numberOfMonths": null,
//                 "type": "hard_skill",
//                 "sources": [
//                     {
//                         "section": "Skills/Interests/Languages",
//                         "position": null
//                     }
//                 ]
//             }
//         ],
//         "languages": [
//             "English"
//         ],
//         "summary": "I am an IT project manager with holistic knowledge of software development and design. I am also experienced in coordinating with stakeholders.",
//         "websites": [],
//         "linkedin": null,
//         "totalYearsExperience": 8,
//         "profession": "Senior Project Manager",
//         "workExperience": [
//             {
//                 "jobTitle": "Project Manager",
//                 "organization": "Westheon FGW",
//                 "location": null,
//                 "dates": {
//                     "startDate": "2017-10-01",
//                     "endDate": "2022-05-27",
//                     "monthsInPosition": 56,
//                     "isCurrent": true
//                 },
//                 "jobDescription": "Conduct day-to-day project coordination, planning, and implementation across multiple teams Create functional and technical application documents ",
//                 "occupation": {
//                     "jobTitle": "Project Manager",
//                     "jobTitleNormalized": "Product/Project Manager",
//                     "classification": {
//                         "socCode": 3556,
//                         "title": "Sales accounts and business development managers",
//                         "minorGroup": "Sales, Marketing and Related Associate Professionals",
//                         "subMajorGroup": "BUSINESS AND PUBLIC SERVICE ASSOCIATE PROFESSIONALS",
//                         "majorGroup": "ASSOCIATE PROFESSIONAL OCCUPATIONS"
//                     },
//                     "managementLevel": "Mid"
//                 }
//             },
//             {
//                 "jobTitle": "Senior UX Designer",
//                 "organization": "Pixelpoint Hive",
//                 "location": null,
//                 "dates": {
//                     "startDate": "2014-01-01",
//                     "endDate": "2017-09-01",
//                     "monthsInPosition": 44,
//                     "isCurrent": false
//                 },
//                 "jobDescription": "Managed complex projects from start to finish Collaborated with other designers Translated requirements into polished, high-level designs ",
//                 "occupation": {
//                     "jobTitle": "Senior UX Designer",
//                     "jobTitleNormalized": "UX Designer",
//                     "classification": null,
//                     "managementLevel": "Low"
//                 }
//             }
//         ],
// "headShot": "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",
//         "isResumeProbability": 79,
//         "rawText": "CONTACT ME AT Office Address: 123 Anywhere St., Any City, State, Country 12345 hello@reallygreatsite.com www.reallygreatsite.com @reallygreatsite\nSKILLS SUMMARY Project Management Software Development Budgeting and Cost Analysis Enterprise Resource Planning Staff and User Training Process Improvement\nAWARDS RECEIVED Most Outstanding Employee of the Year, Pixelpoint Hive (2015) Best Mobile App Design, HGFZ Graduate Center (2014) Design Awards, Cliffmoor College (2012)\nOLIVIAWILSON IT PROJECT MANAGER\nPERSONAL PROFILE I am an IT project manager with holistic knowledge of software development and design. I am also experienced in coordinating with stakeholders.\nWORK EXPERIENCE Project Manager Westheon FGW | Oct 2017 - present Conduct day-to-day project coordination, planning, and implementation across multiple teams Create functional and technical application documents Senior UX Designer Pixelpoint Hive | Jan 2014 - Sept 2017 Managed complex projects from start to finish Collaborated with other designers Translated requirements into polished, high-level designs\nEDUCATIONAL HISTORY HGFZ Graduate Center Masters in Project Management | Jan 2013 - Dec 2014 Studied project planning, coordination, and ethics Worked with various startups on launching new apps and services Cliffmoor College BA Product Design | Dec 2008 - Dec 2012 GPA: 3.26 Minor in Management Thesis involved studying several technology companies and optimizing their product design process"
//     },
//     "meta": {
//         "identifier": "NqDyqJQg",
//         "ready": true,
//         "failed": false,
//         "readyDt": "2022-05-27T08:19:43.975446Z",
//         "fileName": "None",
//         "expiryTime": null
//     },
//     "error": {
//         "errorCode": null,
//         "errorDetail": null
//     }
// }
